var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8752 5.9C14.0352 5.9 14.9752 6.84 14.9752 8C14.9752 9.16 14.0352 10.1 12.8752 10.1C11.7152 10.1 10.7752 9.16 10.7752 8C10.7752 6.84 11.7152 5.9 12.8752 5.9ZM12.8752 14.9C15.8452 14.9 18.9752 16.36 18.9752 17V18.1H6.77524V17C6.77524 16.36 9.90524 14.9 12.8752 14.9ZM12.8752 4C10.6652 4 8.87524 5.79 8.87524 8C8.87524 10.21 10.6652 12 12.8752 12C15.0852 12 16.8752 10.21 16.8752 8C16.8752 5.79 15.0852 4 12.8752 4ZM12.8752 13C10.2052 13 4.87524 14.34 4.87524 17V20H20.8752V17C20.8752 14.34 15.5452 13 12.8752 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.1e835a8e1c8d5540b7f94340cee91e14.svg";
export { ForwardRef as ReactComponent };